import { getPremiumEssentialsSafe } from '@wix/premium-fed-sdk/@premium-essentials';
import { dynamicLoadApiQueries } from './dynamicLoadApiQueries';
const WHOIS_AVAILABILITY_SPEC = 'specs.premium.domains.gateWhoIsAvailbility';
export const getWhoisAvailability = async _ref => {
  let {
    httpClient,
    request: {
      domainName
    }
  } = _ref;
  const {
    experiments,
    referralAdditionalInfo
  } = getPremiumEssentialsSafe() ?? {};
  const {
    getWhoisAvailabilityBase,
    domainsLogger
  } = await dynamicLoadApiQueries(httpClient);
  const isEnabled = experiments == null ? void 0 : experiments[WHOIS_AVAILABILITY_SPEC];

  // If the experiment is enabled, we return true for all domains like in the old concierge behavior
  if (isEnabled) {
    return {
      isTaken: true
    };
  }
  const {
    isTaken
  } = await getWhoisAvailabilityBase({
    domainName
  });
  domainsLogger({
    entity: 'getWhoisAvailability',
    type: 'info',
    message: 'getWhoisAvailability result',
    referralAdditionalInfo,
    metadata: {
      domainName,
      isTaken
    }
  });
  return {
    isTaken
  };
};
//# sourceMappingURL=getWhoisAvailability.js.map